export default __webpack_public_path__ + "static/media/cover_loading.e04da706.svg";